import { PROYECT, api_get, api_post, api_put } from "services/api";

import { METERS_TYPES } from "redux/reducers/buildings/meters/metersTypes";

import { convertToObjById } from "helpers/convertToObject";
import {
  startRequestComp,
  stopRequestComp,
  setSnackbar
} from "redux/actions/search/searchActions";
import { addLabelArray } from "helpers/addLabelArray";

const {
  SET_METERS,
  NEW_METER,
  SET_NEW_METER,
  EDIT_METER,
  SET_EDITED_METER,
  CLEAR_METERS,
  HANDLE_METERS_INPUTS,
} = METERS_TYPES;

const urlMeters = `${process.env.REACT_APP_URL}${PROYECT}/buildings/meters`;
const urlConfig = `${process.env.REACT_APP_URL}${PROYECT}/buildings/configurations`;

export function newMeter() {
  return {
    type: NEW_METER
  };
}
export function clearMeters() {
  return {
    type: CLEAR_METERS
  };
}

export function editMeter(id) {
  return {
    type: EDIT_METER,
    payload: id
  };
}

export const handleMetersInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_METERS_INPUTS, payload: { key, value } });
}

export const fetchMeters = (idStation = null) => async dispatch => {
  dispatch(startRequestComp("fetchMeters"));
  try {
    const [meters, config] = await Promise.all([
      api_get(`${urlMeters}?stations=${idStation}`),
      api_get(urlConfig)
    ]);

    const metersMap = convertToObjById(meters);
    const meterStatuses = addLabelArray(config.meterStatuses);

    dispatch({
      type: SET_METERS,
      payload: {
        meters,
        metersMap,
        meterStatuses
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchMeters"));
};

export const fetchNewMeter = body => async dispatch => {
  dispatch(startRequestComp("fetchNewMeter"));
  try {
    const response = await api_post(urlMeters, body);

    dispatch({
      type: SET_NEW_METER,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchNewMeter"));
};

export const fetchEditMeter = (body, id) => async dispatch => {
  dispatch(startRequestComp("fetchEditMeter"));
  try {
    const response = await api_put(`${urlMeters}/${id}`, body);

    dispatch({
      type: SET_EDITED_METER,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchEditMeter"));
};
